export const PAYU_SHOW_PAY_DEPOSIT = 'payu_show_pay_deposit';
export const SCHEDULE_FULLSCHEDULE_LINK = 'schedule_fullschedule_link';
export const PAYU_ENABLE_PAY_BALANCE = 'payu_enable_pay_balance';
export const PAYU_POSID = 'payu_posid';